import React from 'react';
import { FileText, Trash2 } from 'lucide-react';

export default function DocumentosAdicionalesTable({ items, eliminarItem }) {
  if (items.length === 0) return null;

  return (
    <div style={{ marginTop: '1.5rem' }}>
      <h4 style={{ margin: '0 0 0.8rem', fontSize: '1rem', color: 'var(--text-main)', display: 'flex', alignItems: 'center', gap: 6 }}>
        <FileText size={18} color="var(--primary)" /> Documentos Agregados ({items.length})
      </h4>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Documento</th>
              <th>Datos</th>
              <th>Registro</th>
              <th style={{ width: '60px', textAlign: 'center' }}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item._id}>
                <td style={{ fontWeight: 500 }}>{item.tipo_documento}</td>
                <td>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', fontSize: '0.85rem' }}>
                    {item.tipo_documento !== 'Copia de Documento Agregado' && (
                      <span><strong>Foja:</strong> {item.foja} {item.vta ? '(VTA)' : ''}</span>
                    )}
                    <span><strong>Nº:</strong> {item.numero} | <strong>Año:</strong> {item.anio}</span>
                    {item.nombre_propietario && <span style={{ color: 'var(--text-muted)' }}>Titular: {item.nombre_propietario}</span>}
                  </div>
                </td>
                <td>
                  <span className="badge badge-info">{item.registro}</span>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <button className="btn btn-sm btn-link" onClick={() => eliminarItem(index)} style={{ color: 'var(--danger)', padding: '0.4rem' }} title="Eliminar">
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
